export const ACCESS_TOKEN = 'access_token';
export const ID_TOKEN = 'id_token';
export const EXPIRES_AT = 'expires_at';
export const SETTINGS = 'settings';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/constants/authentication.ts